import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PanelAdministracionView from './PanelAdministracionView';
import * as ROUTES from '../../../router/Routes';

const PanelAdministracionModule = () => {
  return (
    <ContainerTemplate active={ROUTES.panelAdministracion} routes={[]}>
      <PanelAdministracionView />
    </ContainerTemplate>
  );
};

export default PanelAdministracionModule;
